import { AxiosResponse } from 'axios';

import RestAPI from 'components/Common/restApi';

import { VoiceCallDisposition } from './types';

export interface UpdateParams {
  callSid: string;
  reason?: string | undefined;
  customerUuid?: string | undefined;
  notes?: string | undefined;
  jobUuid?: string;
  estimateUuid?: string;
  leadUuid?: string;
  expand?: string[];
}

export default class CallDispositionApi {
  static update({
    callSid,
    reason,
    customerUuid,
    notes,
    jobUuid,
    estimateUuid,
    leadUuid,
    expand,
  }: UpdateParams): Promise<AxiosResponse<VoiceCallDisposition>> {
    return RestAPI.updateWithFormData('/alpha/voice/call_disposition', {
      call_sid: callSid,
      customer_uuid: customerUuid,
      reason,
      notes,
      job_uuid: jobUuid,
      estimate_uuid: estimateUuid,
      lead_uuid: leadUuid,
      expand,
    });
  }
}
